import httpStore from "@/api/httpStore.js";

export function loadPriceGroups() {
  return httpStore.get("/price_groups").then(res => res.data);
}
export function updatePriceGroup(name, retail, repairShop, wholesale) {
  return httpStore
    .post("/price_groups/update", {
      name,
      retail,
      repairShop,
      wholesale
    })
    .then(res => res.data);
}
export function deletePriceGroup(id) {
  return httpStore.delete(`/price_groups?id=${id}`).then(res => res.data);
}
export function createPriceGroup(name, retail, repairShop, wholesale) {
  return httpStore
    .post("/price_groups", {
      name,
      retail,
      repairShop,
      wholesale
    })
    .then(res => res.data);
}
